/**
 * Copyright (c) Qwoach LLC 2026. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

export const LineItemBreakdownMode = Object.freeze({
	DEFAULT: "default",
	GENERAL: "general",
	SUB_ITEMS_ONLY: "subItemsOnly",
	HISTORY_COMPACT: "historyCompact",
	SUMMARY_COMPACT: "summaryCompact",
	QUOTE_PDF: "quotePdf",
})
